<script lang="ts">
  import type { Grade } from '../../../shared/contract'

  /**
   * Fixed difficulty markers, based on the wiki's DifficultyIcon. Status is
   * carried on a separate plate; closing a run never changes its difficulty.
   */
  let {
    grade,
    off = false,
    wide = false,
  }: { grade?: Grade | null; off?: boolean; wide?: boolean } = $props()
</script>

<span class="marker" class:wide class:off aria-hidden="true"><i class="g {grade ?? 'none'}"></i></span>

<style>
  .marker {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: none;
    width: 19px;
    height: 18px;
    border-radius: 1px;
    background: #ffffff;
    vertical-align: middle;
  }
  .marker:has(.double) { width: 25px; }
  .wide { width: 27px; height: 27px; }
  .wide:has(.double) { width: 27px; }
  .g {
    position: relative;
    display: inline-block;
    flex: none;
    width: 12px;
    height: 12px;
    vertical-align: middle;
  }
  .green {
    border-radius: 50%;
    background: var(--green);
  }
  .blue {
    width: 11px;
    height: 11px;
    margin: 0.5px;
    background: var(--blue);
    border-radius: 1px;
  }
  .black::before,
  .double::before,
  .double::after {
    content: '';
    position: absolute;
    top: 1.5px;
    left: 1.5px;
    width: 8px;
    height: 8px;
    background: var(--diamond);
    transform: rotate(45deg);
    border-radius: 0.5px;
  }
  .double {
    width: 19px;
  }
  .double::after {
    left: 9.5px;
  }
  .none::before {
    content: '';
    position: absolute;
    inset: 3px;
    border-radius: 50%;
    background: #586771;
  }
  .off { box-shadow: 0 0 0 1px #152b2535; }
</style>
